<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="设备日志详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">设备标题:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.deviceTitle }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">类型:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.basic && showForm.basic.method == 'send'">发送</el-tag>
          <el-tag v-else type="info">接收</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">action:</el-col>
        <el-col :span="19">
          {{ showForm.basic.method == 'send' ? (showForm.basic.action === '' ? '查询' : (showForm.basic.action > 0 ? `启动:${showForm.basic.action}` : '停止')) : showForm.basic.action }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">lock:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.lock }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">内容:</el-col>
        <el-col :span="19">
          {{ showForm.basic && showForm.basic.text }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">记录时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'AlfmeierLogDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      this.showForm = {
        ...row
      }
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
